<template>
  <component
    :is="type"
    class="ticket-container"
    :class="{
      'ticket-container--waiting-payment': registration.waiting_payment,
      'ticket-container--has-bundle': registration.bundle_parent && !isBundleChild,
      'dea-border-grey-medium': !registration.bundle_parent || isBundleChild,
    }"
  >
    <div class="xs-12 l-6">
      <CardEvent
        :event="registration.linked_event"
        :registration="registration"
        :legs="[]"
        :deleted="registration.state === $root.data.config.states.Cancelled"
        :on_hold="registration.state === $root.data.config.states.on_hold"
        columns
        card-layout="ticket"
      ></CardEvent>
    </div>
    <div class="xs-12 l-6 ticket-container__buttons-container">
      <Buttons
        v-if="
          registration.linked_event.type !== 'online-course' &&
            registration.is_active &&
            registration.past &&
            registration.is_certificate_eligible &&
            !registration.survey_completed_date &&
            registration.linked_event.has_survey &&
            registration.dea_certificate_is_allowed
        "
        class="dea-button--large dea-button--full dea-button--iconRight"
        icon="go-to"
        @click="$emit('completeSurvey')"
        >Compila il questionario e scarica l'attestato</Buttons
      >
      <Buttons
        v-if="
          registration.linked_event.type === 'online-course' &&
            registration.is_active &&
            registration.past &&
            registration.is_certificate_eligible &&
            !registration.survey_completed_date &&
            registration.linked_event.has_survey &&
            registration.dea_certificate_is_allowed
        "
        class="dea-button--large dea-button--full dea-button--iconRight"
        icon="go-to"
        @click="$emit('completeSurvey')"
      >
        Corso completato
        <br />Rispondi al questionario e scarica attestati
      </Buttons>
      <!-- FIXME: Change registration.check_seats_url from BE -->
      <Buttons
        v-if="registration.check_seats_url"
        class="dea-button--large dea-button--full dea-button--iconRight"
        icon="go-to"
        type="a"
        :href="registration.check_seats_url"
        >Completa iscrizione</Buttons
      >
      <!-- FIXME: Change registration.order_url from BE -->
      <Buttons
        v-if="
          registration.to_be_completed &&
            !registration.waiting_payment &&
            (registration.state === 'new' || registration.state === 'completed')
        "
        class="dea-button--large dea-button--full dea-button--iconRight"
        icon="go-to"
        type="a"
        :href="registration.order_url"
        >Completa iscrizione</Buttons
      >
      <Buttons
        v-if="registration.to_be_completed && registration.waiting_payment"
        class="dea-button--large dea-button--full dea-button--iconRight"
        icon="go-to"
        type="a"
        :href="registration.order_url"
        >Finalizza pagamento</Buttons
      >
      <Buttons
        v-if="registration.dea_certificate_available && registration.dea_certificate_url"
        class="dea-button--large dea-button--full dea-button--iconRight"
        icon="download"
        type="a"
        :href="registration.dea_certificate_url"
        target="_blank"
        >Scarica attestato</Buttons
      >
      <Buttons
        v-if="
          registration.ticket_required &&
            registration.ticket_url &&
            !registration.online_event_url &&
            !registration.past &&
            registration.state === $root.data.config.states.Tickets
        "
        class="dea-button--large dea-button--full"
        icon="download"
        type="a"
        :href="registration.ticket_url"
        target="_blank"
        >Scarica il biglietto</Buttons
      >
      <Buttons
        v-if="
          registration.linked_event.type === 'video-lesson' &&
            registration.video_lesson_url &&
            registration.state === $root.data.config.states.Tickets
        "
        class="dea-button--large dea-button--full dea-button--iconRight"
        type="a"
        icon="go-to"
        :href="registration.video_lesson_url"
        >Guarda la videolezione</Buttons
      >
      <Buttons
        v-if="registration.online_event_url && !registration.past && registration.is_active"
        class="dea-button--large dea-button--full"
        icon="go-to"
        type="a"
        target="_blank"
        :href="registration.online_event_url"
        >{{ registration.join_online_seminar_button_label }}</Buttons
      >
      <Buttons
        v-if="registration.webinar_link && !registration.past && registration.is_active"
        class="dea-button--large dea-button--full"
        icon="go-to"
        type="a"
        target="_blank"
        :href="registration.webinar_link"
        >{{ registration.join_webinar_button_label }}</Buttons
      >
      <Buttons
        v-if="
          registration.linked_event.type === 'online-course' &&
            registration.online_course_link &&
            !registration.linked_event.is_past_date &&
            registration.state === $root.data.config.states.Tickets
        "
        class="dea-button--large dea-button--full"
        icon="go-to"
        type="a"
        target="_blank"
        :href="registration.online_course_link"
        >Vai ai corsi</Buttons
      >
      <div
        v-if="registration.is_active && registration.past && registration.is_processing_attendances"
        class="dea-heading--medium__s ticket-container__certificate-message"
      >
        Stiamo generando il tuo attestato.
        <br />Se la tua presenza sarà certificata, riceverai una mail
      </div>
      <div
        v-if="
          registration.is_active &&
            registration.past &&
            !registration.is_processing_attendances &&
            registration.is_event_attended &&
            !registration.is_event_time_reached &&
            !registration.survey_completed_date &&
            registration.linked_event.has_survey
        "
        class="dea-heading--medium__s ticket-container__certificate-message"
      >
        La tua presenza a questo evento non è stata sufficiente, non è quindi possibile generare per te un attestato
      </div>
      <template v-if="registration.state === $root.data.config.states.Tickets">
        <Buttons
          v-for="(link, index) in registration.linked_event.documents"
          :key="index"
          class="dea-button--small dea-button--full dea-button--outline"
          icon="download"
          type="a"
          :href="link.full_url"
          target="_blank"
          :aria-label="`Scarica ${link.description}`"
          >{{ link.description }}</Buttons
        >
      </template>
      <Buttons
        v-if="
          registration.is_event_attended &&
            (registration.survey_completed_date || !registration.linked_event.has_survey) &&
            registration.linked_event.has_private_documents
        "
        class="dea-button--small dea-button--full dea-button--outline"
        icon="download"
        @click="$emit('downloadFiles')"
        >Scarica materiali</Buttons
      >
      <Buttons
        v-if="
          registration.ical_url &&
            !registration.past &&
            registration.cancellable &&
            registration.linked_event.start_date
        "
        class="dea-button--small dea-button--full dea-button--outline"
        icon="add"
        @click="isModalOpen = !isModalOpen"
        >Aggiungi al calendario</Buttons
      >
    </div>
    <div class="xs-12 l-8 actions">
      <Links
        v-if="registration.has_labs && registration.editable && editable"
        class="dea-links--small dea-links--align-left dea-link--color-secondary-formazione dea-button--full dea-links--pointer"
        icon="edit"
        @click="$emit('editLaboratories')"
        >Modifica laboratori</Links
      >
      <Buttons
        v-if="registration.cancellable && registration.order_data.free && editable && cancellable"
        class="dea-links--small dea-links--align-left dea-link--color-secondary-formazione dea-links--pointer"
        icon="close"
        @click="$emit('cancelRegistration')"
        >Cancella iscrizione</Buttons
      >
      <Links
        v-if="false"
        class="dea-links--small dea-links--align-left dea-link--color-secondary-formazione dea-button--full dea-links--pointer"
        >Dettagli sull'ordine</Links
      >
    </div>
    <div class="xs-12 l-4 ticket-container__buttons-container">
      <Links
        v-if="registration.sofia_certificate_available"
        class="dea-links--small dea-link--color-secondary-formazione dea-button--full dea-links--pointer"
        target="_blank"
        >Vai all'attestato S.O.F.I.A.</Links
      >
    </div>
    <div v-if="bundleItems.length" class="xs-12 generic-container__list-events">
      <div class="dea-heading--regular__m generic-container__list-intro">
        Comprende:
      </div>
      <template v-for="packageRegistration in bundleItems">
        <div :key="packageRegistration.id">
          <Links class="dea-links dea-links--align-left dea-links--no-border dea-heading--medium__sm">{{
            packageRegistration.linked_event.title
          }}</Links>
        </div>
      </template>
    </div>
    <div v-if="registration.bundle_parent && !isBundleChild" class="xs-12 generic-container--has-bundle">
      <span class="icon-container">
        !
      </span>
      <span>
        Questo evento è parte di un pacchetto.
        <a class="dea-heading--regular__s" href="#" @click.prevent="openEvent(registration.bundle_parent)">
          Vedi tutti gli eventi del pacchetto
        </a>
      </span>
    </div>
    <Modal
      class="dea-modal--calendar dea-modal--no-footer"
      :visible="isModalOpen"
      :is-error="false"
      @modalClose="isModalOpen = false"
    >
      <template #title>Aggiungi al calendario</template>
      <template #content>
        <Links
          :href="registration.ical_url"
          icon="freccia-right"
          target="_blank"
          class="dea-links--no-border dea-links--full-width dea-heading--medium__ms dea-links--pointer"
          >Calendario Outlook e iCal</Links
        >
        <Links
          v-if="registration.google_calendar_url"
          :href="registration.google_calendar_url"
          icon="freccia-right"
          target="_blank"
          class="dea-links--no-border dea-links--full-width dea-heading--medium__ms dea-links--pointer"
          >Calendario Google</Links
        >
      </template>
    </Modal>
  </component>
</template>
<script>
import Buttons from "@/components/elements/Buttons";
import CardEvent from "@/components/patterns/CardEvent";
import Links from "@/components/elements/Links";
import Modal from "@/components/patterns/Modal";
import { createFocusTrap } from "focus-trap";

export default {
  name: "TicketCard",
  components: {
    Buttons,
    CardEvent,
    Links,
    Modal,
  },
  props: {
    registration: {
      type: Object,
      default: () => {},
    },
    editable: {
      type: Boolean,
      default: true,
    },
    cancellable: {
      type: Boolean,
      default: true,
    },
    colorMod: {
      type: String,
      default: "",
    },
    bgMod: {
      type: String,
      default: "",
    },
    packageChildren: {
      type: Array,
      default: () => [],
    },
    isBundleChild: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "div",
    },
  },
  data() {
    let bundleItems = [];
    if (this.registration.to_be_completed && this.packageChildren.length) bundleItems = this.packageChildren;
    return {
      isModalOpen: false,
      focusTrap: null,
      bundleItems,
    };
  },
  watch: {
    isModalOpen(val) {
      if (val) {
        this.$nextTick(() => {
          const modalEl = this.$el.querySelector(".dea-modal--calendar");
          if (!modalEl) return;

          if (this.focusTrap === null) {
            this.focusTrap = createFocusTrap(modalEl, {
              onDeactivate: () => {
                this.isModalOpen = false;
              },
              onPostDeactivate: () => {
                this.focusTrap = null;
              },
              escapeDeactivates: true,
              allowOutsideClick: true,
            });
            this.focusTrap.activate();
          }
        });
      } else if (this.focusTrap) {
        this.focusTrap.deactivate();
      }
    },
  },
  beforeDestroy() {
    if (this.focusTrap) this.focusTrap.deactivate();
  },
  methods: {
    setTen(num) {
      if (num.toString().length === 1) {
        return `0${num}`;
      }
      return num;
    },
    createDate(dt) {
      return `${this.setTen(dt.getDate())}/${this.setTen(dt.getMonth() + 1)}/${dt.getFullYear()}`;
    },
    createHours(dt) {
      return `${this.setTen(dt.getHours())}:${this.setTen(dt.getMinutes())}`;
    },
    openEvent(id) {
      this.$router.push({ name: "events-package", params: { registration: id } });
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/system.utils";

.ticket-container {
  @include media("<=s") {
    margin-left: $space-base;
    margin-right: $space-base;
  }

  background-color: $dea-color-white;
  border: $border-bold;
  border-radius: $border-radius-large;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0 $space-large;
  margin-bottom: $space-large;
  padding: $space-small 0;

  &--waiting-payment {
    margin-bottom: 0;
  }

  &--has-bundle {
    border-color: $dea-color-target-magenta-formazione;
  }

  &__buttons-container {
    @include media("<=m") {
      align-items: center;
    }

    align-items: flex-end;
    display: flex !important; //sass-lint:disable-line no-important
    flex-direction: column;

    .dea-button {
      @include media("<s") {
        width: 100%;
      }
    }

    .dea-button:not(:last-child),
    .dea-links:not(:last-child) {
      margin-bottom: $space-xx-small;

      &:first-child {
        margin-bottom: $space-base;
      }
    }
  }

  &__certificate-message {
    margin: auto;
  }

  .actions .dea-links {
    margin-left: $space-small;

    &:first-of-type {
      margin-left: 0;
    }
  }

  .dea-modal--calendar {
    .dea-modal {
      margin: 0 auto;
      position: relative;
      top: 30%;
    }

    .dea-modal__title-container {
      margin-bottom: $space-base;
    }

    .dea-links--full-width {
      margin-bottom: $space-base;
      width: 100%;

      .dea-links__label {
        font-size: $h-font-size-medium;
      }
    }
  }
}

.icon-container {
  align-items: center;
  background-color: $dea-color-target-magenta-formazione;
  border-radius: 50%;
  color: $dea-color-white;
  display: flex;
  font-family: $font-primary-bold;
  font-weight: $font-weight-bold;
  height: $space-small;
  justify-content: center;
  width: $space-small;

  .icon {
    color: $dea-color-white;
    font-size: $space-xm-small;
  }
}

.generic-container {
  &--has-bundle {
    align-items: center;
    border-top: $border-bold $dea-color-target-magenta-formazione;
    column-gap: $space-x-small;
    display: flex;
    padding-top: $space-small;

    a {
      border-bottom: $border-bold $dea-color-target-magenta-formazione;
    }
  }
}
</style>
